import { PropsWithChildren } from 'react';
import { LocalizedText, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Banner, Link, Stack, StackItem, Typography } from '@optimus-web/core';

export const CardSharingDisabledBanner = ({ children }: PropsWithChildren<{}>) => (
    <Stack vertical spacing="200">
        <Banner variant="info" primaryText={lt('PaymentsConfigurationCardSharingBannerDescription')} />
        <StackItem>
            <Typography textStyle="bodyMedium" as="div">
                {lt('PaymentsConfigurationCardSharingMissingAdminRights')}
            </Typography>
            {children}
        </StackItem>
        <Typography textStyle="bodyMedium" as="div">
            <LocalizedText
                textKey={TextKey.PaymentsConfigurationCardSharingContactMews}
                substitutes={{
                    a: (text) => (
                        // TODO: Add correct link
                        <Link href="/" target="_blank" rel="noreferrer">
                            {text}
                        </Link>
                    ),
                }}
            />
        </Typography>
        <Typography textStyle="bodyMedium" as="div">
            {lt('PaymentsConfigurationTermsAndConditionsPrompt')}
        </Typography>
    </Stack>
);
